import { EngineContext } from 'engine/components/EngineProvider';
import { FILTER_GLOW_ID } from 'game/defs/FilterGlow';
import { PATTERN_LINES_ID } from 'game/defs/PatternLines';
import { ScannerBehavior } from 'game/entities/lab/LabWallDoorEntity';
import { ModuleType } from 'game/state/BotState';
import { memo, useContext } from 'react';
import { ModuleComponentProps } from './ModuleProps';

const ScannerModuleStatic: React.FC = memo(() => (
  <>
    <linearGradient id="Gradient1" x1="0" x2="0" y1="0" y2="1">
      <stop offset="0%" stopColor="#fff8b8" stopOpacity={0} />
      <stop offset="90%" stopColor="#fff8b8" />
      <stop offset="100%" stopColor="#fff8b8" stopOpacity={0} />
    </linearGradient>
    <clipPath id="clipPath">
      <path d="M0 140H500V470H0z" />
    </clipPath>

    <path fill="#f2f2f2" d="M0.5 0.5H499.5V599.5H0.5z" />
    <path fill="#4d4d4d" d="M499 1v598H1V1h498m1-1H0v600h500V0z" />
    <circle cx="430" cy="520" r="19.5" fill="#ff1d25" />
    <path
      fill="#c1272d"
      d="M430 501a19 19 0 11-19 19 19 19 0 0119-19m0-1a20 20 0 1020 20 20 20 0 00-20-20z"
    />
    <g fill="#fff" opacity="0.75">
      <circle cx="430" cy="521" r="9.5" />
      <path d="M430 512a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z" />
    </g>
    <circle cx="430" cy="520" r="9.5" />
    <path
      fill="#c1272d"
      d="M430 511a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z"
    />
    <text
      fontSize="27.77"
      transform="translate(257.04 530.38)"
    >
      ACCEPTED
    </text>
    <g opacity="0.8">
      <circle cx="34.75" cy="35.75" r="14.75" fill="#fff" />
      <circle
        cx="34.75"
        cy="35.75"
        r="14.75"
        fill="none"
        stroke="#fff"
      />
    </g>
    <circle cx="34.75" cy="34.75" r="14.75" fill="#ccc" />
    <circle
      cx="34.75"
      cy="34.75"
      r="14.75"
      fill="none"
      stroke="gray"
    />
    <path
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      d="M29.5 30.5L39.5 40.5"
      opacity="0.8"
    />
    <path
      fill="none"
      stroke="#333"
      strokeWidth="2"
      d="M29.5 29.5L39.5 39.5"
    />
    <path
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      d="M39.5 30.5L29.5 40.5"
      opacity="0.8"
    />
    <path
      fill="none"
      stroke="#333"
      strokeWidth="2"
      d="M39.5 29.5L29.5 39.5"
    />
    <g opacity="0.8">
      <circle cx="464.75" cy="35.75" r="14.75" fill="#fff" />
      <circle
        cx="464.75"
        cy="35.75"
        r="14.75"
        fill="none"
        stroke="#fff"
      />
    </g>
    <circle cx="464.75" cy="34.75" r="14.75" fill="#ccc" />
    <circle
      cx="464.75"
      cy="34.75"
      r="14.75"
      fill="none"
      stroke="gray"
    />
    <path
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      d="M459.5 30.5L469.5 40.5"
      opacity="0.8"
    />
    <path
      fill="none"
      stroke="#333"
      strokeWidth="2"
      d="M459.5 29.5L469.5 39.5"
    />
    <path
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      d="M469.5 30.5L459.5 40.5"
      opacity="0.8"
    />
    <path
      fill="none"
      stroke="#333"
      strokeWidth="2"
      d="M469.5 29.5L459.5 39.5"
    />
    <g opacity="0.8">
      <circle cx="34.75" cy="565.75" r="14.75" fill="#fff" />
      <circle
        cx="34.75"
        cy="565.75"
        r="14.75"
        fill="none"
        stroke="#fff"
      />
    </g>
    <circle cx="34.75" cy="564.75" r="14.75" fill="#ccc" />
    <circle
      cx="34.75"
      cy="564.75"
      r="14.75"
      fill="none"
      stroke="gray"
    />
    <path
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      d="M29.5 560.5L39.5 570.5"
      opacity="0.8"
    />
    <path
      fill="none"
      stroke="#333"
      strokeWidth="2"
      d="M29.5 559.5L39.5 569.5"
    />
    <path
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      d="M39.5 560.5L29.5 570.5"
      opacity="0.8"
    />
    <path
      fill="none"
      stroke="#333"
      strokeWidth="2"
      d="M39.5 559.5L29.5 569.5"
    />
    <g opacity="0.8">
      <circle cx="464.75" cy="565.75" r="14.75" fill="#fff" />
      <circle
        cx="464.75"
        cy="565.75"
        r="14.75"
        fill="none"
        stroke="#fff"
      />
    </g>
    <circle cx="464.75" cy="564.75" r="14.75" fill="#ccc" />
    <circle
      cx="464.75"
      cy="564.75"
      r="14.75"
      fill="none"
      stroke="gray"
    />
    <path
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      d="M459.5 560.5L469.5 570.5"
      opacity="0.8"
    />
    <path
      fill="none"
      stroke="#333"
      strokeWidth="2"
      d="M459.5 559.5L469.5 569.5"
    />
    <path
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      d="M469.5 560.5L459.5 570.5"
      opacity="0.8"
    />
    <path
      fill="none"
      stroke="#333"
      strokeWidth="2"
      d="M469.5 559.5L459.5 569.5"
    />
    <path fill="#1a1a1a" d="M0 140H500V470H0z" />
    <path d="M68.19 73.07v10.4h7v-10.4h7.26v27.23h-7.26V89.84h-7v10.46h-7.26V73.07zM100.77 73.07l11.09 27.23H104l-1.65-4.52h-10l-1.65 4.52h-7.76L94 73.07zm-.83 16.34l-2.54-6.47-2.54 6.47zM119.61 73.07l9.77 15.18V73.07h7.26v27.23h-7.26l-9.77-15.18v15.18h-7.26V73.07zM148.25 73.07a13.62 13.62 0 110 27.23h-8.38V73.07zm-1.12 20.73h.26c4.1 0 6.7-3.1 6.74-7.1s-2.58-7.13-6.74-7.13h-.26zM183.17 72.58a17.55 17.55 0 018.83 2.34l-2.87 5.84a12.32 12.32 0 00-5.45-1.58c-1.71 0-2.64.56-2.64 1.75 0 .56.43 1.22 3.07 2.21 3.54 1.32 8.52 3.69 8.52 8.61 0 6.93-5.28 9.08-10.69 9.08-6.9 0-10.57-3.14-10.57-3.14l3.6-6.17s3.63 2.58 7.1 2.58c1.75 0 2.57-.63 2.57-1.92 0-1.65-2.11-2.61-5.61-4.19-3.13-1.42-5.11-4-5.11-6.8.01-5.28 4.76-8.61 9.25-8.61zM207.55 72.58c5.94 0 9 2.41 9 2.41l-3.07 6.2a8.39 8.39 0 00-4.78-1.48c-6 0-8.16 4.12-8.16 7s2.21 7 8.16 7a8.36 8.36 0 004.78-1.49l3.07 6.21s-3 2.41-9 2.41c-7.62 0-14.88-6.34-14.88-14.13s7.26-14.13 14.88-14.13z" />
    <path d="M233.29 73.07l11.09 27.23h-7.82l-1.65-4.52h-10l-1.65 4.52h-7.82l11.09-27.23zm-.82 16.34l-2.54-6.47-2.54 6.47zM252.13 73.07l9.77 15.18V73.07h7.27v27.23h-7.27l-9.77-15.18v15.18h-7.26V73.07zM279.66 73.07l9.77 15.18V73.07h7.26v27.23h-7.26l-9.77-15.18v15.18h-7.26V73.07zM316 73.07v6.37h-8.84v4h8.45v6.37h-8.45v4.09H316v6.37h-16.1v-27.2zM329.82 73.07c5.28 0 9.47 2.71 9.47 8.58A8.46 8.46 0 01334 90l8.81 10.33h-9.2l-7.33-9.44v9.44h-7.26V73.07zm-3.5 11.78h1.12c1.95 0 4.19-.42 4.19-3s-2.24-3-4.19-3h-1.12z" />
    <path d="M480 519.92L460 509.92 460 529.92 480 519.92z" />
    <path fill="#ccc" d="M20 80H50V100H20z" />
    <path fill="#ccc" d="M350 80H480V100H350z" />
  </>
));

export const ScannerModuleComponent: React.FC<ModuleComponentProps<ModuleType.Scanner>> = ({ bot }) => {
  const engine = useContext(EngineContext);
  const scanner = bot.getFacet(ScannerBehavior);
  if (!scanner) return null;
  let progress: null | number = null;
  if (scanner.scanStart) {
    progress = (engine.time.now - scanner.scanStart) / scanner.scanDuration;
  }

  return (
    <>
      <ScannerModuleStatic />

      <g filter={`url(#${FILTER_GLOW_ID})`}>
        <path
          fill="none"
          stroke="#fff8b8"
          strokeWidth="2"
          d="M333.35 305.62c-9.14 2.08-17.68 18.89-31.8 33.94V205.34a13.32 13.32 0 00-13.3-13.3h-1.48a13.31 13.31 0 00-13.3 13.3l-.17 87.15-5.53-.5V177.42a13.31 13.31 0 00-13.3-13.3H253a13.32 13.32 0 00-13.3 13.3v117.74l-4.26.52-.17-101a13.33 13.33 0 00-13.36-13.3h-1.47a13.32 13.32 0 00-13.31 13.3l.16 108.32-3.44.5-.34-82.67a13.31 13.31 0 00-13.3-13.3h-1.48a13.32 13.32 0 00-13.3 13.3V292h-.16v94.53s0 56.33 63.16 56.33c39.42 0 56.06-18.39 61.26-30.93.05-.05 39.19-68.42 47.34-84.13s-1.86-24.92-13.68-22.18z"
        />
        {progress && (
          <rect width={500} height={50} y={90 + progress * 500} fill="url(#Gradient1)" clipPath="url(#clipPath)" />
        )}
      </g>
      <path fill={`url(#${PATTERN_LINES_ID})`} d="M0 140H500V470H0z" />
    </>
  );
};
